// extracted by mini-css-extract-plugin
export default {"team-dropdown":"AvailableEmployee_team-dropdown__YF9bI","availability-dropdown":"AvailableEmployee_availability-dropdown__0ibt4"};